import PlatformManagement from './platformManagement' //平台方管理
import Fence from './fence'

//运营
export default [
    {
        path: 'operate',
        name: 'operate',
        meta: {
            title: '运营',
            icon: 'operate'
        },
        hidden: false,
        component: () => import("@/views/operate/index.vue"),
        children:[
            ...PlatformManagement,
            ...Fence
        ]
    }

]